export function hexToRgba(hex: string, alpha: number): string {
  const h = hex?.replace('#', '') || '000000';
  const full = h.length === 3 ? h.split('').map(c => c + c).join('') : h.padStart(6, '0').slice(0, 6);
  const r = parseInt(full.slice(0, 2), 16);
  const g = parseInt(full.slice(2, 4), 16);
  const b = parseInt(full.slice(4, 6), 16);
  if ([r, g, b].some(n => Number.isNaN(n))) return `rgba(0,0,0,${alpha})`;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export function formatDate(dateString: string | undefined): string {
  if (!dateString) return '-';
  try {
    if (dateString.includes('T')) {
      const [tarihKismi] = dateString.split('T');
      const [yil, ay, gun] = tarihKismi.split('-');
      return `${gun}.${ay}.${yil}`;
    }
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return dateString;
    const localDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    return new Intl.DateTimeFormat('tr-TR', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(localDate);
  } catch {
    return dateString;
  }
}

export function formatCurrency(amount: number | undefined, currency: string = 'TRY'): string {
  if (typeof amount !== 'number') return '-';
  return new Intl.NumberFormat('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}
